/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RepostOfRepostNotificationAction } from './RepostOfRepostNotificationAction';
import {
    RepostOfRepostNotificationActionFromJSON,
    RepostOfRepostNotificationActionFromJSONTyped,
    RepostOfRepostNotificationActionToJSON,
} from './RepostOfRepostNotificationAction';

/**
 * 
 * @export
 * @interface RepostOfRepostNotification
 */
export interface RepostOfRepostNotification {
    /**
     * 
     * @type {string}
     * @memberof RepostOfRepostNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof RepostOfRepostNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof RepostOfRepostNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof RepostOfRepostNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<RepostOfRepostNotificationAction>}
     * @memberof RepostOfRepostNotification
     */
    actions: Array<RepostOfRepostNotificationAction>;
}

/**
 * Check if a given object implements the RepostOfRepostNotification interface.
 */
export function instanceOfRepostOfRepostNotification(value: object): value is RepostOfRepostNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function RepostOfRepostNotificationFromJSON(json: any): RepostOfRepostNotification {
    return RepostOfRepostNotificationFromJSONTyped(json, false);
}

export function RepostOfRepostNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepostOfRepostNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(RepostOfRepostNotificationActionFromJSON)),
    };
}

export function RepostOfRepostNotificationToJSON(value?: RepostOfRepostNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(RepostOfRepostNotificationActionToJSON)),
    };
}

